import { Link as RouterLink } from "react-router-dom";
import { twMerge } from "tailwind-merge";

export function Link({
  children,
  ...props
}: React.ComponentProps<typeof RouterLink>) {
  return (
    <RouterLink
      {...props}
      className={twMerge(
        "hover:underline text-indigo-600 dark:text-indigo-400 hover:text-indigo-700 dark:hover:text-indigo-300",
        props.className
      )}
    >
      {children}
    </RouterLink>
  );
}
